import {
  ALLOWED_PRICE_STEPS_PER_PTU,
  PRICE_AREA_AGGREGATED_PARTNER_CODES,
  SINGLE_PRICE_STEP_PARTNER_CODES,
} from '@/features/bidding/constants'
import type { AggregatedBidPtu } from '@/features/bidding/utils/model/buildAggregatedBid'
import type { AggregatedBidWrapper } from '@/features/bidding/utils/model/mapActivationGroupBidsToAggregatedBids'

export function getUniquePricesFromAllActivationGroups(
  ptu: AggregatedBidPtu,
  bidsPerActivationGroup: Map<string, AggregatedBidWrapper>,
): number {
  const uniquePrices = new Set<number>()

  for (const otherBidWrapper of bidsPerActivationGroup.values()) {
    const otherPtu = otherBidWrapper.aggregatedBid.ptus.find((p) => p.ptuStart.equals(ptu.ptuStart))
    if (otherPtu) {
      otherPtu.priceQuantities.filter((pq) => pq.quantity !== 0).forEach((pq) => uniquePrices.add(pq.price))
    }
  }

  return uniquePrices.size
}

export function getCountOfNonZeroPriceQuantities(ptu: AggregatedBidPtu): number {
  return ptu.priceQuantities.filter((pq) => pq.quantity !== 0).length
}

export function isSinglePriceStepPartner(partnerCode: string): boolean {
  return SINGLE_PRICE_STEP_PARTNER_CODES.includes(partnerCode.toUpperCase())
}

/** Partners whose activation groups collapse into one price-area bid; narrower than isSinglePriceStepPartner. */
export function isPriceAreaAggregatedPartner(partnerCode: string): boolean {
  return PRICE_AREA_AGGREGATED_PARTNER_CODES.includes(partnerCode.toUpperCase())
}

export function exceedsAllowedPriceStepsPerPtu(ptu: AggregatedBidPtu): boolean {
  return getCountOfNonZeroPriceQuantities(ptu) > ALLOWED_PRICE_STEPS_PER_PTU
}

/** Zero-volume steps are ignored; no map means no breach. */
export function hasConflictingPricesAcrossActivationGroups(
  ptu: AggregatedBidPtu,
  bidsPerActivationGroup?: Map<string, AggregatedBidWrapper>,
): boolean {
  if (bidsPerActivationGroup === undefined) {
    return false
  }

  return getUniquePricesFromAllActivationGroups(ptu, bidsPerActivationGroup) > ALLOWED_PRICE_STEPS_PER_PTU
}
